import { Observable } from 'rxjs';

export type ResourceStatus = 'Idle' | 'Downloading' | 'Cancled' | 'Cached' | 'Error';
export type GroupStatus = 'Idle' | 'Downloading' | 'Cancled' | 'Cached' | 'Error';

/**
* Download state event of a single mote resource (image, video, sound or map tile)
*/
export class ResourceState<T = any> {
    status: ResourceStatus = 'Idle';
    percentage: number = 0;
    url: string;
    name?: string; // The name of the download resource (shown to the user)
    groupId?: string; // Project key the resource state belongs to
    moteKey?: string; // The key of the mote that the resource belongs to
    bytesTransfered?: number; // Number of bytes transfers (currently always 0 or 100% of size)
    bytesTotal?: number; // Size of resource
    error?: Error;
    context?: T;

    constructor(url: string, name: string, groupId: string, moteKey: string) {
        this.url = url;
        this.name = name;
        this.groupId = groupId;
        this.moteKey = moteKey;
    }

    public clone() {
        return Object.assign(Object.create(Object.getPrototypeOf(this)), this)
    }
}

/**
* Total caching progress event (for a list of resources)
*/
export class CacheProgress {
    resources: ResourceState[];
    lastResourceState: ResourceState;
    totalPct: number = 0;
    totalBytes: number = 0;
    msg: string = "";
}

/**
 * Caching state of a motes project/world
 * Obs: This is saved in client cache so changes needs to be backward compatible
 */
export class GroupState {
    id?: string;
    status: GroupStatus;
    totalPct: number = 0;
    totalBytes = 0;
    abortCtrl?: AbortController;
    resourceList?: ObservableValue<ResourceState>[] = [];
}

/**
 * Map of cached projects
 */
export type GroupStateMap = { [groupId: string]: GroupState };

/**
 * Observable that enables access/storage of the last emitted value
 */
export class ObservableValue<T> extends Observable<T> {
    public lastVal: T = null;
}
